export const VERDICTS = {
  not_a_photograph: { label: 'NOT A PHOTOGRAPH', tone: 'neutral', glyph: '◇' },
  likely_authentic: { label: 'LIKELY AUTHENTIC', tone: 'positive', glyph: '●' },
  uncertain: { label: 'UNCERTAIN', tone: 'warning', glyph: '◐' },
  likely_manipulated_or_false: { label: 'LIKELY MANIPULATED', tone: 'negative', glyph: '▲' },
};

export const TONE_COLOR_VAR = {
  positive: 'var(--accent-green)',
  warning: 'var(--accent-amber)',
  negative: 'var(--accent-red)',
  neutral: 'var(--fg-dim)',
};
